module.exports = __webpack_public_path__ + "img/09_maska_4-kvadrata.e628b44.svg";